// The cases a chat's cases card lists (components/BoardCasesCard.jsx), by
// the call that put the card in the chat: what the chat is about as much as
// a case added to it is (lib/chatSubject.js), so the reader asks about them
// without adding each. Each entry is { item, keep }: the case as "Add to
// chat" hands it, and how to keep it in the inbox's store, for a note the
// chat writes on it. Held for the page; a card drawn again lists them again.
const shown = new Map();
// Cards held at most, the oldest let go first.
const CARDS_MAX = 24;

export function showChatCases(callId, entries) {
    const id = String(callId || "");
    if (!id) return;
    shown.delete(id);
    if (Array.isArray(entries) && entries.length) shown.set(id, entries);
    while (shown.size > CARDS_MAX) shown.delete(shown.keys().next().value);
}

/** The cases the card the call `callId` put in a chat lists: [{ item, keep }]. */
export function chatCasesShown(callId) {
    return shown.get(String(callId || "")) || [];
}

/** Keeps the case `caseId` a card lists, before the chat notes on it; false where no card lists it. */
export function keepShownCase(caseId) {
    for (const entries of shown.values()) {
        const hit = entries.find((e) => e?.item?.spec?.caseId === caseId);
        if (hit) {
            hit.keep?.();
            return true;
        }
    }
    return false;
}

export function _resetChatShownCasesForTests() {
    shown.clear();
}
